<template>
	<div class="productDetail" :style="{'height': clientHeight+'px' }">
		<el-button type="primary" plain class="backClass" @click="backClick()">返回</el-button>
		<div class="headerBox2">
			基本信息
			<el-button type="primary" plain class="addButtonClass" @click="editClick()">编辑</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="productList" style="width: 100%" v-loading="loading">
				<el-table-column prop="model" label="产品型号" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="规约类型" min-width="1%">
					<template slot-scope="scope">{{scope.row.ruler_type|ruler_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="password" label="通讯密码" min-width="1%">
				</el-table-column>
				<el-table-column prop="fee_num" label="费率个数" min-width="1%">
				</el-table-column>
				<el-table-column prop="user_type" label="用户类型" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="波特率" min-width="1%">
					<template slot-scope="scope">{{scope.row.rate_type|rate_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="" label="接线方式" min-width="1%">
					<template slot-scope="scope">{{scope.row.join_type|join_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="rated_v" label="额定电压" min-width="1%">
				</el-table-column>
				<el-table-column prop="rated_a" label="额定电流" min-width="1%">
				</el-table-column>
			</el-table>
			<el-table :data="productList" style="width: 100%">
				<el-table-column prop="p_code" label="资产号" min-width="1%">
				</el-table-column>
				<el-table-column prop="parser_id" label="抄读方式" min-width="1%">
				</el-table-column>
				<!--<el-table-column prop="todo" label="事件方式" min-width="1%">
				</el-table-column>-->
				<el-table-column prop="" label="" min-width="6%">
				</el-table-column>
			</el-table>
		</div>
		<div class="parser_itemBox">
			<div class="parser_item" v-for="item in parserItemList2" v-if="item.checked==true">
				<span>{{item.name}}</span>
				<span style="margin-left: 10px;">{{item.code}}</span>
			</div>
		</div>
		<div class="headerBox2">是否支持补抄</div>
		<div class="content">
			<div class="yesLi">
				<el-radio v-model="isrepair" label="是" @change="radioClick()">是</el-radio>
			</div>
			<div class="yesLi">
				<el-radio v-model="isrepair" label="否" @change="radioClick()">否</el-radio>
			</div>
		</div>
		<div class="headerBox2">采集数据项
			<el-button type="primary" plain class="addButtonClass" @click="selectClick2()">筛选数据项</el-button>
		</div>
		<div class="content">
			<div :class="[item.selected?'ergencyLi':'ergencyLi2']" v-for="item in productItemData2">
				<el-checkbox v-model="item.checked" disabled>{{item.title}}</el-checkbox>
			</div>
		</div>
		<!--<div class="headerBox2">
			能耗数据项
			<el-button type="primary" plain class="addButtonClass" @click="selectClick()">筛选数据项</el-button>
		</div>
		<div class="content">
			<div :class="[item.selected?'ergencyLi':'ergencyLi2']" v-for="item in productItemData1">
				<el-checkbox v-model="item.checked" disabled>{{item.title}}</el-checkbox>
			</div>
		</div>-->
		<div class="headerBox2">
			数据项显示分类
			<el-button type="primary" plain class="addButtonClass" @click="setClassClick('','',1)">设置分类</el-button>
		</div>
		<div class="content">
			<div class="yesLi" v-for="item in productClassData1">
				<el-checkbox v-model="item.checked" disabled>{{item.name}}</el-checkbox>
				<i class="iconfont icon-bianji eidtClass3" @click="setClassClick(item.id,item,1)"></i>
				<span>
					<i class="iconfont icon-guanbi closeClass3" @click="classDelete(item.id)"></i>
				</span>
			</div>
		</div>
		<div class="headerBox2">事件
			<el-button type="primary" plain class="addButtonClass" @click="setClassClick('','',2)">设置分类</el-button>
		</div>
		<div class="content">
			<div class="yesLi2" v-for="item in productClassData2">
				<el-checkbox v-model="item.checked" disabled><span class="sanClass">{{item.name}}</span></el-checkbox>
				<span class="riskSign" @click="setTingClick(item.name,item.id,item.lev)" v-if="item.lev==3">高风险</span>
				<span class="riskSign2" @click="setTingClick(item.name,item.id,item.lev)" v-if="item.lev==2">中风险</span>
				<span class="riskSign3" @click="setTingClick(item.name,item.id,item.lev)" v-if="item.lev==1">低风险</span>
				<span class="riskSign0" @click="setTingClick(item.name,item.id,item.lev)" v-if="item.lev==0">无风险</span>
				<i class="iconfont icon-bianji eidtClass" @click="setClassClick(item.id,item,2,item.lev)"></i>
				<span>
					<i class="iconfont icon-guanbi closeClass4" @click="classDelete(item.id)"></i>
				</span>
			</div>
		</div>
		<div class="headerBox2">特殊计算显示项</div>
		<div class="content">
			<div class="yesLi">
				<el-checkbox v-model="special1" @change="radioClick()">线路复合率</el-checkbox>
			</div>
			<div class="yesLi">
				<el-checkbox v-model="special2" @change="radioClick()">三相电流不平衡率</el-checkbox>
			</div>
		</div>
		<div class="headerBox2">控制
			<el-button type="primary" plain class="addButtonClass" @click="setContrlClick()">设置控制</el-button>
		</div>
		<div class="content">
			<div class="yesLi" v-for="item in contrlList">
				<el-checkbox v-model="checked" disabled>{{item.name}}</el-checkbox>
				<i class="iconfont icon-bianji eidtClass2" @click="contrlEdit(item.id,item)"></i>
				<i class="el-icon-close closeClass" @click="contrlDelete(item.id)"></i>
			</div>
			<div class="yesLi">
				<el-checkbox v-model="ischeck" @change="radioClick()">校时</el-checkbox>
			</div>
		</div>
		<div class="pagination">
			<!--<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>-->
		</div>
		<!--弹窗1(新建控制)-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="控制名称" label-width="20%">
					<el-input type="text" v-model="name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="数据标识" label-width="20%">
					<el-input type="text" v-model="code" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="枚举值" label-width="20%">
					<el-input type="text" v-model="item" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="附加数" label-width="20%">
					<el-input type="text" v-model="ext" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="单位" label-width="20%">
					<el-input type="text" v-model="unit" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="类型" label-width="20%">
					<el-select v-model="type" placeholder="请选择" style="width:100%" clearable>
						<el-option v-for="item in typeData" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="contorlSave()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--弹窗2(能耗数据项)-->
		<div class="specilDialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth2" :close-on-click-modal="false">
				<div class="checkAllBox">
					<el-checkbox v-model="checkedAllErgency" @change="checkedAllChange(productItemList1,checkedAllErgency)">全选</el-checkbox>
				</div>
				<div :class="[item.selected?'ergencyLi':'ergencyLi2']" v-for="item in productItemList1">
					<el-checkbox v-model="item.checked" @change="checkedRadioChange(productItemList1,'能耗数据项')">{{item.title}}</el-checkbox>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="productItemSave(1)" class="confrim" type="primary">立即创建</el-button>
					<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>
		<!--弹窗6(采集数据项)-->
		<div class="specilDialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible6" :width="dialogWidth2" :close-on-click-modal="false">
				<div class="checkAllBox">
					<el-checkbox v-model="checkedAllCollect" @change="checkedAllChange(productItemList2,checkedAllCollect)">全选</el-checkbox>
				</div>
				<div :class="[item.selected?'ergencyLi':'ergencyLi2']" v-for="item in productItemList2">
					<el-checkbox v-model="item.checked" @change="checkedRadioChange(productItemList2,'采集数据项')">{{item.title}}</el-checkbox>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="productItemSave(2)" class="confrim" type="primary">立即创建</el-button>
					<el-button @click="dialogFormVisible6=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>
		<!--弹窗3(数据显示分类/数据事件分类)-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible3" :width="dialogWidth2" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="分类名称" label-width="20%">
					<div style="width:87%;">
						<el-input type="text" v-model="nameValue" autocomplete="off"></el-input>
					</div>
				</el-form-item>
			</el-form>
			<div class="checkAllBox">
				<el-checkbox v-model="checkedAllTitle" @change="checkedAllChange(titleData,checkedAllTitle)">全选</el-checkbox>
			</div>
			<div :class="[item.selected?'ergencyLi':'ergencyLi2']" v-for="item in titleData">
				<el-checkbox v-model="item.checked" @change="checkedRadioChange(titleData,'显示事件分类')">{{item.title}}</el-checkbox>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="productClassSave()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible3=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--弹窗4(数据事件分类事件等级)-->
		<div class="fourthdialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible4" :width="dialogWidth" :close-on-click-modal="false">
				<i class="iconfont icon-duihao successBox"></i>
				<div class="riskBox" @click="circleHandle(3)">
					<span class="circle2" :class="{'circleSpecil' : circleNumber == 3}"></span>
					<span class="riskSign">高风险</span>
				</div>
				<div class="riskBox" @click="circleHandle(2)">
					<span class="circle2" :class="{'circleSpecil' : circleNumber == 2}"></span>
					<span class="riskSign2">中风险</span>
				</div>
				<div class="riskBox" @click="circleHandle(1)">
					<span class="circle2" :class="{'circleSpecil' : circleNumber == 1}"></span>
					<span class="riskSign3">低风险</span>
				</div>

				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible4=false" class="cancle">取消</el-button>
					<el-button @click="productClassSave(1)" class="confrim" type="primary">确定</el-button>
				</div>
			</el-dialog>
		</div>
		<!--弹窗5-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible5" :width="dialogWidth2" :close-on-click-modal="false" style="margin-top: 0;">
			<el-form>
				<el-form-item label="型号" label-width="20%">
					<el-input type="text" v-model="model" autocomplete="off" @change="modelChange"></el-input>
				</el-form-item>
				<el-form-item label="规约类型" label-width="20%">
					<el-select v-model="ruler_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in ruler_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="通信密码" label-width="20%">
					<el-input type="text" v-model="password" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="费率个数" label-width="20%">
					<el-input type="text" v-model="fee_num" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="用户类型" label-width="20%">
					<el-input type="text" v-model="user_type" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="波特率" label-width="20%">
					<el-select v-model="rate_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in rate_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="接线方式" label-width="20%">
					<el-select v-model="join_type" placeholder="请选择" style="width:100%">
						<el-option v-for="item in join_typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="额定电压" label-width="20%">
					<el-input type="text" v-model="rated_v" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="额定电流" label-width="20%">
					<el-input type="text" v-model="rated_a" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="资产号" label-width="20%">
					<el-input type="text" v-model="p_code" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="抄读方式" label-width="20%">
					<el-select v-model="parser_id" placeholder="请选择" style="width:100%" @change="getParserItemList(parser_id)">
						<el-option v-for="item in parserList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<!--<el-form-item label="事件方式" label-width="20%">
					<el-select v-model="value" placeholder="请选择" style="width:100%">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>-->
				<el-button size='small' plain type="primary" class="nowdataClass" @click="setNowData(parser_id)">配置实时数据</el-button>
				<div class="specilCheckBox">
					<div class="parserClass" v-for="item in parserItemList" v-if="item.checked==true">
						<!--<el-checkbox v-model="item.checked" :disabled="!parser_id">{{item.name}}</el-checkbox>-->
						<div class="nameClass2">{{item.code}}</div>
						<div class="nameClass2">{{item.code}}</div>
					</div>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="baseSave()" class="confrim" type="primary">保存</el-button>
				<el-button @click="dialogFormVisible5=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--实时数据弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible10" :width="dialogWidth2" :close-on-click-modal="false">
			<div>
				<span style="display:inline-block;margin-bottom: 20px;">抄读方式：{{parserName}}</span>
				<div class="checkAllBox">
					<el-checkbox v-model="checkedAll" @change="checkedAllChange2()">全选</el-checkbox>
				</div>
				<div :class="[item.selected?'parserClass2':'parserClass3']" v-for="item in parserItemList">
					<el-checkbox v-model="item.checked" @change="checkedRadioChange2()">{{item.name}}</el-checkbox>
					<div :class="[item.selected?'nameClass33':'nameClass22']" v-if="item.selected==true">{{item.code}}</div>
					<div :class="[item.checked?'nameClass33':'nameClass22']" v-if="item.selected==false">{{item.code}}</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible10=false" class="confrim" type="primary">确认</el-button>
				<el-button @click="dialogFormVisible10=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.firstPageIndex = this.$route.query.fI
			//获取某个类距离顶部的距离
			var offset = $(".productDetail").offset()
			//某个id的高度（注意：要是id）
			//var box1 =document.getElementById("home_headerB").offsetHeight
			this.clientHeight = document.body.clientHeight - offset['top']
			this.product_id = this.$route.query.id
			this.category_id = this.$route.query.category_id
			this.getList(); //基础信息
			this.getReadItemWithFlagFun(); //获取某产品下所有可选实时读配置，并标记已选中的
			this.getConctrlLst(); //控制列表
			this.getProductItemList(); //能耗数据项、采集数据项列表
			this.getProductClassList(); //显示分类/事件分类列表
			window.addEventListener('resize', () => {
				//获取某个类距离顶部的距离
				var offset = $(".productDetail").offset()
				//某个id的高度（注意：要是id）
				//var box1 =document.getElementById("home_headerB").offsetHeight
				this.clientHeight = document.body.clientHeight - offset['top']
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
					this.dialogWidth2 = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "80%"
					this.dialogWidth2 = "80%"
				} else {
					this.dialogWidth = "55%"
					this.dialogWidth2 = "55%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
				this.dialogWidth2 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "80%"
				this.dialogWidth2 = "80%"
			} else {
				this.dialogWidth = "55%"
				this.dialogWidth2 = "55%"
			}
		},
		computed: {
			...mapGetters(['http', 'http2'])
		},
		data() {
			return {
				loading: false, //加载状态
				clientHeight: '', //滚动高度
				pageSize: 20, //每页条数
				firstPageIndex: '', //第一个页面的当前页
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogFormVisible3: false,
				dialogFormVisible4: false,
				dialogFormVisible5: false,
				dialogFormVisible6: false,
				title: '', //弹窗标题
				product_id: '', //产品id
				category_id: '', //分类id
				productList: [], //产品列表
				titleData: [], //数据项列表
				contrlList: [], //控制列表
				productItemList1: [], //能耗数据项(选中、未选中状态（弹窗）)
				productItemList2: [], //采集数据项(选中、未选中状态（弹窗）)
				productItemData1: [], //能耗数据项(列表)
				productItemData2: [], //能耗数据项(列表)
				productClassData1: [], //数据项显示分类(列表)
				productClassData2: [], //事件分类(列表)
				showClassList: [], //显示分类
				thingClassList: [], //事件分类
				ischeck: '', //是否校时 
				isrepair: '', //是否抄录
				special1: '', //是否线路复合率
				special2: '', //是否三相电流不平衡率
				dialogWidth: '55%', //dialog的宽度
				dialogWidth2: '55%', //dialog的宽度
				checked: true,
				radio: '1',
				circleNumber: 0,
				/*表单1----控制信息*/
				name: '',
				code: '',
				item: '',
				ext: '',
				unit: '',
				type: '',
				/*表单2----能耗数据项、采集数据项*/
				/*表单3----数据项显示分类*/
				nameValue: '', //名称
				classEdit_id: '', //编辑的id
				valValue: '', //数据项显示分类的区分
				levValue: '', //事件分类的风险等级
				/*表单4----事件*/

				/*表单5---基本信息编辑*/
				model: '', //型号
				ruler_type: '', //规约类型
				ruler_typeList: [{
						id: 0,
						name: '未知（0）'
					},
					{
						id: 1,
						name: 'DL/T 645-1997（1）'
					},
					{
						id: 2,
						name: 'DL/T 645—2007（2）'
					},
					{
						id: 3,
						name: 'DL/T 698.45（3）'
					},
					{
						id: 4,
						name: 'CJ/T 188—2004（4）'
					},
					{
						id: 5,
						name: 'ModBus（5）'
					},
				], //规约类型列表
				password: '', //通信密码
				fee_num: '', //费率个数
				user_type: '', //用户类型
				rate_type: '', //波特率
				rate_typeList: [{
						id: 255,
						name: '自适应（偶校验）'
					},
					{
						id: 0,
						name: '300bps（偶校验）'
					},
					{
						id: 1,
						name: '600bps（偶校验）'
					},
					{
						id: 2,
						name: '1200bps（偶校验）'
					},
					{
						id: 3,
						name: '2400bps（偶校验）'
					},
					{
						id: 4,
						name: '4800bps（偶校验）'
					},
					{
						id: 5,
						name: '7200bps（偶校验）'
					},
					{
						id: 6,
						name: '9600bps（偶校验）'
					},
					{
						id: 7,
						name: '19200bps（偶校验）'
					},
					{
						id: 8,
						name: '38400bps（偶校验）'
					},
					{
						id: 9,
						name: '57600bps（偶校验）'
					},
					{
						id: 10,
						name: '115200bps（偶校验）'
					},
					{
						id: 128,
						name: '300bps（无校验）'
					},
					{
						id: 129,
						name: '600bps（无校验）'
					},
					{
						id: 130,
						name: '1200bps（无校验）'
					},
					{
						id: 131,
						name: '2400bps（无校验）'
					},
					{
						id: 132,
						name: '4800bps（无校验）'
					},
					{
						id: 133,
						name: '7200bps（无校验）'
					},
					{
						id: 134,
						name: '9600bps（无校验）'
					},
					{
						id: 135,
						name: '19200bps（无校验）'
					},
					{
						id: 136,
						name: '38400bps（无校验）'
					},
					{
						id: 137,
						name: '57600bps（无校验）'
					},
					{
						id: 138,
						name: '115200bps（无校验）'
					}
				], //波特率列表
				join_type: '', //接线方式
				join_typeList: [{
						id: 0,
						name: '未知（0）'
					},
					{
						id: 1,
						name: '单相（1）'
					},
					{
						id: 2,
						name: '三相三线（2）'
					},
					{
						id: 3,
						name: '三相四线（3）'
					},
				], //接线方式列表
				rated_v: '', //额定电压
				rated_a: '', //额定电流
				p_code: '', //资产号
				parser_id: '', //抄读方式
				parserList: [], //抄读方式列表
				checkedAllErgency: false, //能耗全选
				checkedAllCollect: false, //采集全选
				checkedAllTitle: false, //显示事件分类全选
				parserItemList: [],
				checkedAll: false,
				parserItemList2: [],
				dialogFormVisible10: false,
				parserName: '',
				typeData: []
			}
		},
		filters: {
			join_typeFilter: function(val) {
				if(val == "0") {
					return "未知";
				}
				if(val == "1") {
					return "单相";
				}
				if(val == "2") {
					return "三相三线";
				}
				if(val == "3") {
					return "三相四线";
				}
			},
			ruler_typeFilter: function(val) {
				if(val == "0") {
					return "未知";
				}
				if(val == "1") {
					return "DL/T 645-1997";
				}
				if(val == "2") {
					return "DL/T 645—2007";
				}
				if(val == "3") {
					return "DL/T 698.45";
				}
				if(val == "4") {
					return "CJ/T 188—2004";
				}
				if(val == "5") {
					return "ModBus";
				}
			},
			rate_typeFilter: function(val) {
				if(val == "255") {
					return "自适应（偶校验）";
				}
				if(val == "0") {
					return "300bps（偶校验）";
				}
				if(val == "1") {
					return "600bps（偶校验）";
				}
				if(val == "2") {
					return "1200bps（偶校验）";
				}
				if(val == "3") {
					return "2400bps（偶校验）";
				}
				if(val == "4") {
					return "4800bps（偶校验）";
				}
				if(val == "5") {
					return "7200bps（偶校验）";
				}
				if(val == "6") {
					return "9600bps（偶校验）";
				}
				if(val == "7") {
					return "19200bps（偶校验）";
				}
				if(val == "8") {
					return "38400bps（偶校验）";
				}
				if(val == "9") {
					return "57600bps（偶校验）";
				}
				if(val == "10") {
					return "115200bps（偶校验）";
				}
				if(val == "128") {
					return "300bsp（无校验）";
				}
				if(val == "129") {
					return "600bsp（无校验）";
				}
				if(val == "130") {
					return "1200bsp（无校验）";
				}
				if(val == "131") {
					return "2400bsp（无校验）";
				}
				if(val == "132") {
					return "4800bsp（无校验）";
				}
				if(val == "133") {
					return "7200bsp（无校验）";
				}
				if(val == "134") {
					return "9600bsp（无校验）";
				}
				if(val == "135") {
					return "19200bsp（无校验）";
				}
				if(val == "136") {
					return "38400bsp（无校验）";
				}
				if(val == "137") {
					return "57600bsp（无校验）";
				}
				if(val == "138") {
					return "115200bsp（无校验）";
				}
			},
		},
		methods: {
			/*
			 * 配置实时数据
			 * */
			//全选、全不选
			checkedAllChange2() {
				if(this.checkedAll == true) {
					this.parserItemList.forEach(item => {
						item.checked = true
					})
				} else {
					this.parserItemList.forEach(item => {
						item.checked = false
					})
				}
			},
			//单选
			checkedRadioChange2(val, signVal) {
				var checkedArr = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == this.parserItemList.length) {
					this.checkedAll = true
				} else {
					this.checkedAll = false
				}
			},
			setNowData(parser_id) {
				this.checkedRadioChange2()
				if(this.parser_id) {
					this.title = "实时抄读设置"
					this.dialogFormVisible10 = true
					this.parserList.forEach(item => {
						if(item.id == parser_id) {
							this.parserName = item.name
						}
					})
				} else {
					this.$message('请先选择抄读方式！');
					this.parserName = ''
				}
			},
			//抄读项列表
			getParserItemList(parser_id) {
				this.checkedAll = false
				this.parserItemList = []
				var params = {
					pageSize: -1,
					pageIndex: 1,
					parser_id: parser_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							item.selected = false
							item.checked = false
						})
						this.parserItemList = res.data
					} else {
						this.parserItemList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//型号光标离开触发
			modelChange() {
				var params = {
					model: this.model
				}
				let config = headers.headers('getByModel')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getByModel', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.model == this.productList[0].model) {
							this.notDo = false
							return
						}
						this.$message('该型号已存在,请重新输入型号！');
						this.notDo = true
						this.model = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			/*
			 *（基础信息）
			 * */
			//抄读项列表
			getParserList() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					category_id: this.category_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.parserList = res.data
						res.data.forEach(item => {
							if(item.id == this.productList[0].parser_id) {
								this.productList.forEach(item_z => {
									item_z.parser_id = item.name
								})
							}
						})
					} else {
						this.parserList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//基础信息列表
			getList() {
				this.loading = true;
				let config = headers.headers(this.product_id)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {}
				axios.get(this.http + '/zkep2/product/' + this.product_id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false;
					//console.log(res)
					if(res.data.id) {
						this.productList = []
						this.productList.push(res.data)
						if(this.productList.length > 0) {
							this.getParserList(); //抄读项列表
						}
						this.productList.forEach(item => {
							item.parser_name = item.parser_id
							if(item.ischeck == 0) {
								item.ischeck = false
							} else {
								item.ischeck = true
							}
							if(item.isrepair == 0) {
								item.isrepair = '否'
							} else {
								item.isrepair = '是'
							}
							if(item.special1 == 0) {
								item.special1 = false
							} else {
								item.special1 = true
							}
							if(item.special2 == 0) {
								item.special2 = false
							} else {
								item.special2 = true
							}
						})
						this.isrepair = this.productList[0].isrepair
						this.special1 = this.productList[0].special1
						this.special2 = this.productList[0].special2
						this.ischeck = this.productList[0].ischeck

					} else {
						this.productList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取某产品下所有可选实时读配置，并标记已选中的
			getReadItemWithFlagFun() {
				var params = {
					product_id: this.product_id,
				}
				let config = headers.headers('getReadItemWithFlag')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product_read/getReadItemWithFlag', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.isselected == 0) {
								item.selected = false
								item.checked = false
							} else if(item.isselected == 1) {
								item.selected = true
								item.checked = true
							}
						})
						var arr = JSON.stringify(res.data)
						this.parserItemList2 = JSON.parse(arr)
						this.parserItemList = JSON.parse(arr)
					} else {
						this.parserItemList2 = []
						this.parserItemList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//基本信息的编辑的点击
			editClick(val) {
				this.getReadItemWithFlagFun()
				this.checkedRadioChange2()
				this.title = "编辑基本信息"
				if(!val) {
					this.dialogFormVisible5 = true
				}
				this.model = this.productList[0].model
				this.ruler_type = this.productList[0].ruler_type
				this.password = this.productList[0].password
				this.fee_num = this.productList[0].fee_num
				this.user_type = this.productList[0].user_type
				this.rate_type = this.productList[0].rate_type
				this.join_type = this.productList[0].join_type
				this.rated_v = this.productList[0].rated_v
				this.rated_a = this.productList[0].rated_a
				this.p_code = this.productList[0].p_code
				this.parser_id = this.productList[0].parser_name
			},
			//基本信息的保存
			baseSave() {
				var ischeck;
				var isrepair;
				var special1;
				var special2;
				if(this.ischeck == true) {
					ischeck = 1
				} else if((this.ischeck == false)) {
					ischeck = 0
				}
				if(this.isrepair == '是') {
					isrepair = 1
				} else if((this.isrepair == '否')) {
					isrepair = 0
				}
				if(this.special1 == true) {
					special1 = 1
				} else if(this.special1 == false) {
					special1 = 0
				}
				if(this.special2 == true) {
					special2 = 1
				} else if(this.special2 == false) {
					special2 = 0
				}
				/*创建时间的处理*/
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				var params = {
					id: this.product_id,
					category_id: this.category_id,
					model: this.model, //型号
					ruler_type: this.ruler_type, //规约类型
					password: this.password, //通信密码
					fee_num: this.fee_num, //费率个数
					user_type: this.user_type, //用户类型
					rate_type: this.rate_type, //波特率
					join_type: this.join_type, //接线方式
					rated_v: this.rated_v, //额定电压
					rated_a: this.rated_a, //额定电流
					p_code: this.p_code, //资产号
					parser_id: this.parser_id, //抄读方式
					ischeck: ischeck, //是否校时
					isrepair: isrepair, //是否抄读
					special1: special1, //是否线路复合率
					special2: special2, //是否三相电流不平衡率
					manager_id: manager_id,
					create_time: timestamp,
					status: 1,
					version: 0
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/product/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.dialogFormVisible5 = false
						this.getList();
						this.delByProduct();
					} else {
						this.$message('编辑失败！');
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//根据产品id删除所有 数据项
			delByProduct() {
				var config = headers.headers('delByProduct')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/product_read/delByProduct',
					qs.stringify({
						product_id: this.product_id
					}), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					this.productReadSave();
				}).catch(err => {
					console.log(err)
				})
				var arrAdd = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) { //添加
						arrAdd.push(item)
					}
				})
			},
			//产品实时抄读内容保存
			productReadSave() {
				var arrAdd = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) { //添加
						arrAdd.push(item)
					}
				})
				//console.log(arrAdd)
				var timestamp = Date.parse(new Date());
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				for(var i = 0; i < arrAdd.length; i++) {
					axios.post(this.http + '/zkep2/product_read/save',
						qs.stringify({
							product_id: this.product_id,
							parser_item_id: arrAdd[i].id,
							create_time: timestamp,
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						this.getList();
						this.getReadItemWithFlagFun()
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//是否超读改变/是否线路复合率/是否三相电流不平衡率
			radioClick() {
				this.editClick('radio');
				this.baseSave();
			},
			//控制类型列表
			getControlTypeList() {
				axios.post(this.http2 + '/zouk/productControl/listTypeSelect', null).then(res => {
					//console.log(res)
					if(res.data.ok) {
						this.typeData = res.data.result
						this.typeData.forEach(item => {
							item.id = Number(item.id)
						})
					} else {
						this.typeData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*
			 * 控制
			 * */
			//控制列表
			getConctrlLst() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					product_id: this.product_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product_control/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res,'contrlList')
					if(res.data.length > 0) {
						this.contrlList = res.data
					} else {
						this.contrlList = []
					}
					this.getControlTypeList()
				}).catch(err => {
					console.log(err)
				})
			},
			//设置控制(控制)
			setContrlClick() {
				this.title = "新建控制"
				this.dialogFormVisible = true
				this.contrlEmpty();
			},
			//控制编辑的点击
			contrlEdit(id, list) {
				this.dialogFormVisible = true
				this.contrl_id = id
				this.name = list.name
				this.code = list.code
				this.item = list.item
				this.ext = list.ext
				this.unit = list.unit
				this.type = list.type
			},
			//控制保存
			contorlSave() {
				if(!this.type) {
					this.type = null
				}
				var timestamp = Date.parse(new Date());
				var params = {
					id: this.contrl_id,
					product_id: this.product_id,
					name: this.name,
					code: this.code,
					item: this.item,
					ext: this.ext,
					unit: this.unit,
					create_time: timestamp,
					status: 1,
					version: 0
				}
				if(this.type) {
					params['type'] = this.type
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/product_control/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.dialogFormVisible = false
						this.getConctrlLst();
					} else {
						this.$message('操作失败！');
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//控制删除
			contrlDelete(id) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/product_control/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getConctrlLst();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//控制清空
			contrlEmpty() {
				this.contrl_id = ''
				this.name = ''
				this.code = ''
				this.item = ''
				this.ext = ''
				this.unit = ''
				this.type = ''
			},
			/*
			 * 能耗数据项/采集数据项*/
			//筛选(能耗数据项)
			selectClick() {
				this.getProductItem(1); //能耗数据项（选中、未选中（弹窗）
				if(this.productItemData1.length == 0) {
					this.title = "建立能耗数据项"
				} else {
					this.title = "编辑能耗数据项"
				}
				this.dialogFormVisible2 = true
			},
			//筛选(采集数据项)
			selectClick2() {
				this.getProductItem(2); //能耗数据项（选中、未选中（弹窗））
				if(this.productItemData2.length == 0) {
					this.title = "建立采集数据项"
				} else {
					this.title = "编辑采集数据项"
				}
				this.dialogFormVisible6 = true
			},
			//能耗数据项/采集数据项(选中、未选中)
			getProductItem(val) {
				var params = {
					product_id: this.product_id,
					type: val,
				}
				let config = headers.headers('getAllTitleByProductAndType')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product_item/getAllTitleByProductAndType', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach((item, index) => {
							if(item.selected == 0) {
								item.selected = false
								item.checked = false
							} else {
								item.selected = true
								item.checked = true
							}
						})
						if(val == 1) {
							this.productItemList1 = res.data
						} else if(val == 2) {
							this.productItemList2 = res.data
						}

					} else {
						if(val == 0) {
							this.productItemList1 = []
						} else if(val == 1) {
							this.productItemList2 = []
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//能耗数据项/采集数据项(列表)
			getProductItemList() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					product_id: this.product_id,
				}
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product_item/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					this.productItemData1 = []
					this.productItemData2 = []
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.selected = false
								item.checked = false
							} else {
								item.selected = true
								item.checked = true
							}
							if(item.type == 1) { //能耗数据项列表
								this.productItemData1.push(item)
							} else if(item.type == 2) { //采集数据项列表
								this.productItemData2.push(item)
							}
						})
					} else {
						this.productItemData1 = []
						this.productItemData2 = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//能耗数据项/采集数据项(保存)
			async productItemSave(val) {
				var timestamp = Date.parse(new Date());
				var arr = []
				if(val == 1) {
					if(this.productItemData1.length > 0) {
						//批量删除
						let config = headers.headers('deleteByProductAndType')
						var pass_token = config.pass_token
						var timestamp = config.timestamp
						var params = {
							product_id: this.product_id,
							type: 1
						}
						//console.log(params)
						const res1 = await axios.post(this.http + '/zkep2/product_item/deleteByProductAndType', qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data) {
								this.getConctrlLst();
							}
						}).catch(err => {
							console.log(err)
						})
					}
					this.productItemList1.forEach(item => {
						if(item.checked == true) {
							arr.push(item.id)
						}
					})
				} else if(val == 2) {
					if(this.productItemData2.length > 0) {
						//批量删除
						let config = headers.headers('deleteByProductAndType')
						var pass_token = config.pass_token
						var timestamp = config.timestamp
						var params = {
							product_id: this.product_id,
							type: 2
						}
						//console.log(params)
						const res2 = await axios.post(this.http + '/zkep2/product_item/deleteByProductAndType', qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data) {
								this.getConctrlLst();
							}
						}).catch(err => {
							console.log(err)
						})
					}
					this.productItemList2.forEach(item => {
						if(item.checked == true) {
							arr.push(item.id)
						}
					})
				}
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				//todo
				if(arr.length > 0) {
					for(var i = 0; i < arr.length; i++) {
						axios.post(this.http + '/zkep2/product_item/save',
							qs.stringify({
								product_id: this.product_id,
								type: val,
								title_code: arr[i],
								create_time: timestamp,
								status: 1,
								version: 0,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {
								if(val == 1) {
									this.dialogFormVisible2 = false
								} else if(val == 2) {
									this.dialogFormVisible6 = false
								}
								this.getProductItemList();
							} else {
								this.$message('操作失败！');
							}
						}).catch(err => {
							console.log(err)
						})
					}
				} else {
					if(val == 1) {
						this.dialogFormVisible2 = false
					} else if(val == 2) {
						this.dialogFormVisible6 = false
					}
					this.getProductItemList();
				}
			},
			/*
			 * 数据项显示分类、事件分类
			 * todo
			 * */
			//数据项列表
			titleList() {
				var params = {
					product_id: this.product_id,
					product_classification_id: 0
				}
				let config = headers.headers('getAllTitleByClassification')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/classification_item/getAllTitleByClassification', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.checked = false
							}
						})
						this.titleData = res.data
					} else {
						this.titleData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//设置分类的点击(数据项显示分类/事件分类)
			setClassClick(id, list, val, lev) {
				this.checkedAllTitle = false
				this.levValue = lev
				this.valValue = val;
				if(id) { //编辑
					this.classEdit_id = id;
					this.title = "编辑显示分类"
					this.nameValue = list.name
					this.getProductclassification(this.classEdit_id);
				} else { //添加
					this.emptyProductClass();
					this.title = "建立显示分类"
					this.titleList(); //数据项列表
				}
				this.dialogFormVisible3 = true
			},
			//设置分类等级(事件)
			setTingClick(name, id, lev) {
				this.circleNumber = lev
				this.valValue = 2;
				this.nameValue = name
				this.title = '"' + name + '"' + "事件等级划分"
				this.dialogFormVisible4 = true
				this.classEdit_id = id
			},
			circleHandle(val) {
				this.circleNumber = val
			},
			//数据显示分类/事件分类(列表)
			getProductClassList() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					product_id: this.product_id,
				}
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product_classification/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					this.productClassData1 = []
					this.productClassData2 = []
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.selected = false
								item.checked = false
							} else {
								item.selected = true
								item.checked = true
							}
							if(item.type == 1) { //数据项显示分类列表
								this.productClassData1.push(item)
							} else if(item.type == 2) { //事件分类列表
								this.productClassData2.push(item)
							}
						})
					} else {
						this.productClassData1 = []
						this.productClassData2 = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//数据显示分类/事件分类(主保存)
			productClassSave(val) {
				var lev;
				if(this.classEdit_id) { //编辑
					if(this.valValue == 1) {
						lev = 0
					} else if(this.valValue == 2) {
						if(val) {
							lev = this.circleNumber
						} else {
							lev = this.levValue
						}
					}
				} else { //添加
					lev = 0
				}
				var timestamp = Date.parse(new Date());
				var arr = []
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: this.classEdit_id,
					product_id: this.product_id,
					type: this.valValue,
					lev: lev,
					name: this.nameValue,
					create_time: timestamp,
					status: 1,
					version: 0,
				}
				//console.log(params)
				axios.post(this.http + '/zkep2/product_classification/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.valValue == 1) {
							this.dialogFormVisible3 = false
						} else if(this.valValue == 2) {
							if(val) {
								this.dialogFormVisible4 = false
							} else {
								this.dialogFormVisible3 = false
							}
						}
						this.dialogFormVisible3 = false
						this.getProductClassList();
						var arr = []
						this.titleData.forEach(item => {
							if(item.checked == true) {
								arr.push(item.id)
							}
						})
						if(this.classEdit_id) { //编辑
							let config = headers.headers('deleteByClassification')
							var pass_token = config.pass_token
							var timestamp = config.timestamp
							var params = {
								product_classification_id: this.classEdit_id
							}
							//console.log(params)
							axios.post(this.http + '/zkep2/classification_item/deleteByClassification', qs.stringify(params), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
								//console.log(res)
								let config = headers.headers('save')
								var pass_token = config.pass_token
								var timestamp = config.timestamp
								for(var i = 0; i < arr.length; i++) {
									axios.post(this.http + '/zkep2/classification_item/save',
										qs.stringify({
											product_classification_id: this.classEdit_id,
											title_code: arr[i],
											create_time: timestamp,
											status: 1,
											version: 0,
										}), {
											headers: {
												'pass-token': pass_token,
												'time': timestamp
											}
										}).then(res => {
										//console.log(res)
										if(res.data.id) {} else {
											this.$message('操作失败！');
										}
									}).catch(err => {
										console.log(err)
									})
								}
							}).catch(err => {
								console.log(err)
							})
						} else {
							let config = headers.headers('save')
							var pass_token = config.pass_token
							var timestamp = config.timestamp
							for(var i = 0; i < arr.length; i++) {
								axios.post(this.http + '/zkep2/classification_item/save',
									qs.stringify({
										product_classification_id: res.data.id,
										title_code: arr[i],
										create_time: timestamp,
										status: 1,
										version: 0,
									}), {
										headers: {
											'pass-token': pass_token,
											'time': timestamp
										}
									}).then(res => {
									//console.log(res)
									if(res.data.id) {} else {
										this.$message('操作失败！');
									}
								}).catch(err => {
									console.log(err)
								})
							}
						}
					} else {
						this.$message('操作失败！');
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//数据显示分类/事件分类清空
			emptyProductClass() {
				this.classEdit_id = ''
				this.nameValue = ''
			},
			//数据显示分类/事件分类删除
			classDelete(id) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/product_classification/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getProductClassList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			/*todo*/
			//数据显示分类/事件分类
			getProductclassification(id) {
				var params = {
					product_id: this.product_id,
					product_classification_id: id
				}
				let config = headers.headers('getAllTitleByClassification')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/classification_item/getAllTitleByClassification', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						//1：显示分类，2：事件分类
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.selected = false
								item.checked = false
							} else {
								item.selected = true
								item.checked = true
							}
						})
						this.titleData = res.data
					} else {
						this.titleData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//返回
			backClick() {
				this.$router.push({
					path: '/product/product',
					name: 'Product',
					query: {
						fI: this.firstPageIndex
					}
				})
			},
			//全选、全不选
			checkedAllChange(val, checkedVal) {
				if(checkedVal == true) {
					val.forEach(item => {
						item.checked = true
					})
				} else {
					val.forEach(item => {
						item.checked = false
					})
				}
			},
			//单选
			checkedRadioChange(val, signVal) {
				var checkedArr = []
				val.forEach(item => {
					if(item.checked == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == val.length) {
					if(signVal == '能耗数据项') {
						this.checkedAllErgency = true
					} else if(signVal == '采集数据项') {
						this.checkedAllCollect = true
					} else if(signVal == '显示事件分类') {
						this.checkedAllTitle = true
					}
				} else {
					if(signVal == '能耗数据项') {
						this.checkedAllErgency = false
					} else if(signVal == '采集数据项') {
						this.checkedAllCollect = false
					} else if(signVal == '显示事件分类') {
						this.checkedAllTitle = false
					}
				}
			},
		}
	}
</script>

<style>
	.productDetail {
		/*height: 612px;*/
		overflow: auto;
		/*height: 100%;*/
		padding: 0 12% 0 12%;
		position: relative;
	}
	
	.productDetail .backClass {
		margin-top: 3.2%;
		padding: 8px 22px;
		font-size: 13px;
		margin-bottom: 24px;
	}
	
	.productDetail .addButtonClass {
		position: absolute;
		top: 4px;
		right: 1%;
		width: 100px;
		padding: 8px 22px;
		font-size: 13px;
	}
	
	.productDetail .headerBox2 {
		position: relative;
		height: 26px;
		line-height: 26px;
		padding: 6px 20px;
		padding-left: 10px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin: 0 10px 10px 10px;
	}
	
	.productDetail .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		margin-bottom: 45px;
	}
	/*表格*/
	
	.productDetail .el-table th {
		color: #000;
	}
	
	.productDetail .el-table {
		font-size: 12px;
	}
	
	.productDetail .el-table th,
	.productDetail .el-table td,
	.productDetail .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.productDetail .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.productDetail .content {
		margin: 20px 10px 40px 10px;
		display: table;
		word-spacing: -1em;
		/*多个div的空隙*/
	}
	
	.productDetail .yesLi,
	.productDetail .yesLi2 {
		position: relative;
		display: inline-block;
		width: 192px;
		height: 34px;
		line-height: 34px;
		background-color: #fff;
		border-radius: 3px;
		padding-left: 10px;
		margin-right: 20px;
		margin-bottom: 10px;
	}
	
	.productDetail .sanClass {
		display: inline-block;
		width: 64px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: top;
	}
	
	.productDetail .yesLi:hover i,
	.productDetail .yesLi2:hover i {
		color: #439DFD;
	}
	
	.productDetail .yesLi:hover span i,
	.productDetail .yesLi2:hover span i {
		color: #E076A6;
	}
	/*单选框*/
	
	.productDetail .el-radio__label {
		font-size: 12px;
		color: #439DFD;
	}
	
	.productDetail .el-radio__inner {
		border: 1px solid #439DFD;
	}
	
	.productDetail .checkAllBox {
		margin-left: 2px;
		margin-bottom: 16px;
	}
	
	.productDetail .checkAllBox .el-checkbox__inner {
		border: 1px solid #6a6a6a!important;
		background-color: #6a6a6a;
		border-radius: 0!important;
	}
	
	.productDetail .checkAllBox .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #409eff;
	}
	
	.productDetail .checkAllBox .el-checkbox__label {
		color: #6a6a6a;
	}
	
	.productDetail .ergencyLi {
		display: inline-block;
		padding-left: 6px;
		height: 32px;
		line-height: 32px;
		width: 164px;
		border: 1px solid #439DFD;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 14px;
		margin-bottom: 10px;
	}
	
	.productDetail .ergencyLi2 {
		display: inline-block;
		padding-left: 6px;
		height: 32px;
		line-height: 32px;
		width: 164px;
		border: 1px solid #6A6A6A;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 14px;
		margin-bottom: 10px;
	}
	/*复选框（原色）*/
	
	.productDetail .el-checkbox {
		color: #439DFD;
	}
	
	.productDetail .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.productDetail .ergencyLi .el-checkbox__label,
	.productDetail .ergencyLi2 .el-checkbox__label,
	.productDetail .yesLi .el-checkbox__label {
		width: 130px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: middle;
	}
	
	.productDetail .el-checkbox__inner {
		border: 1px solid #439DFD!important;
		background-color: #439DFD;
		border-radius: 0!important;
	}
	
	.productDetail .el-checkbox__input.is-checked .el-checkbox__inner,
	.productDetail .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #439DFD;
		border-color: #439DFD!important;
	}
	/*复选框（灰色）*/
	
	.productDetail .ergencyLi2 .el-checkbox {
		color: #6A6A6A;
	}
	
	.productDetail .ergencyLi2 .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.productDetail .ergencyLi2 .el-checkbox__inner {
		border: 1px solid #6A6A6A!important;
		background-color: #6A6A6A;
		border-radius: 0!important;
	}
	
	.productDetail .ergencyLi2 .el-checkbox__input.is-checked .el-checkbox__inner,
	.productDetail .ergencyLi2 .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6A6A6A;
		border-color: #6A6A6A!important;
	}
	
	.productDetail .riskSign0 {
		margin: 0 2px 0 12px;
		padding: 2px;
		font-size: 12px;
		color: #fff;
		background-color: #439DFD;
		vertical-align: top;
		cursor: pointer;
	}
	
	.productDetail .riskSign {
		margin: 0 2px 0 12px;
		padding: 2px;
		font-size: 12px;
		color: #fff;
		background-color: #B7000D;
		vertical-align: top;
		cursor: pointer;
	}
	
	.productDetail .riskSign2 {
		margin: 0 2px 0 12px;
		padding: 2px;
		font-size: 12px;
		color: #fff;
		background-color: #FFB409;
		vertical-align: top;
		cursor: pointer;
	}
	
	.productDetail .riskSign3 {
		margin: 0 2px 0 12px;
		padding: 2px;
		font-size: 12px;
		color: #fff;
		background-color: #6F706B;
		vertical-align: top;
		cursor: pointer;
	}
	
	.productDetail .eidtClass {
		color: #439DFD;
		font-size: 17px;
		margin-left: 6px;
		cursor: pointer;
	}
	
	.productDetail .eidtClass2 {
		position: absolute;
		top: 0;
		right: 24%;
		color: #439DFD;
		font-size: 17px;
		cursor: pointer;
	}
	
	.productDetail .eidtClass3 {
		position: absolute;
		top: 0;
		right: 15%;
		color: #fff;
		font-size: 17px;
		cursor: pointer;
	}
	
	.productDetail .closeClass {
		position: absolute;
		top: 20%;
		right: 4%;
		color: #439DFD;
		font-size: 22px;
		cursor: pointer;
	}
	
	.productDetail .closeClass3 {
		position: absolute;
		top: 0;
		right: 4%;
		color: #fff;
		cursor: pointer;
	}
	
	.productDetail .closeClass4 {
		position: absolute;
		top: 0;
		right: 1%;
		color: #fff;
		cursor: pointer;
	}
	/*弹窗*/
	
	.productDetail .el-dialog__title {
		color: #999;
	}
	
	.productDetail .el-dialog__footer {
		text-align: center;
	}
	
	.productDetail .pagination {
		text-align: center;
	}
	
	.productDetail .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.productDetail .specilDialog .el-dialog__header {
		border-bottom: 1px solid #ebebeb;
	}
	/*第四个弹窗*/
	
	.productDetail .fourthdialog .el-dialog__footer {
		text-align: right;
	}
	
	.productDetail .fourthdialog .el-dialog__title {
		color: #000;
		font-size: 12px;
	}
	
	.productDetail .fourthdialog .el-dialog__title {
		margin-left: 46px!important;
	}
	
	.productDetail .fourthdialog .successBox {
		color: #09BA07;
		font-size: 20px;
		position: absolute;
		top: 11%;
		left: 5%;
	}
	
	.productDetail .fourthdialog .el-dialog__headerbtn .el-dialog__close {
		font-size: 0;
	}
	
	.productDetail .fourthdialog .riskBox {
		display: inline-block;
		margin-left: 10%;
	}
	
	.productDetail .fourthdialog .circleSpecil {
		background-color: #439DFD!important;
	}
	
	.productDetail .fourthdialog .circle2 {
		display: inline-block;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: #666;
		cursor: pointer;
	}
	
	.productDetail .fourthdialog .riskSign {
		margin-left: 2px;
	}
	
	.productDetail .fourthdialog .riskSign2 {
		margin-left: 2px;
	}
	
	.productDetail .fourthdialog .riskSign3 {
		margin-left: 2px;
	}
	/*禁用时复选框样式*/
	
	.productDetail .el-checkbox__input.is-disabled+span.el-checkbox__label {
		color: #439DFD;
		cursor: not-allowed;
	}
	
	.productDetail .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after {
		border-color: #fff;
	}
	/*滚动条的样式*/
	
	.productDetail::-webkit-scrollbar {
		width: 10px;
	}
	
	.productDetail::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	.productDetail::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	
	.productDetail .parser_itemBox {
		border: 1px solid #ccc;
		margin-bottom: 25px;
		background-color: #fff;
		font-size: 13px;
	}
	
	.productDetail .parser_item {
		width: 25%;
		padding: 10px;
		text-align: center;
		display: inline-block;
		border-bottom: 1px solid #ccc;
	}
	
	.productDetail .nowdataClass {
		margin-bottom: 10px;
		margin-left: 4px;
	}
	/*复选框（深色）*/
	
	.productDetail .specilCheckBox .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
		color: #000;
	}
	
	.productDetail .specilCheckBox .el-checkbox__inner {
		border: 1px solid #0079DD!important;
		background-color: #0079DD;
		border-radius: 0!important;
	}
	
	.productDetail .specilCheckBox .el-checkbox__input.is-checked .el-checkbox__inner,
	.productDetail .specilCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0079DD;
		border-color: #0079DD!important;
	}
	
	.productDetail .nameClass2 {
		font-size: 12px;
		height: 18px;
		line-height: 18px;
		text-align: center;
	}
	
	.productDetail .nameClass22 {
		margin-left: 24px;
		font-size: 12px;
		height: 0px;
		line-height: 0px;
	}
	
	.productDetail .nameClass33 {
		color: #439DFD;
		margin-left: 24px;
		font-size: 12px;
		height: 0px;
		line-height: 0px;
	}
	
	.productDetail .parserClass {
		display: inline-block;
		width: 140px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 3px 6px 4px;
		border: 1px solid #439DFD;
		border-radius: 4px;
	}
	
	.productDetail .checkAllBox {
		margin-left: 2px;
		margin-bottom: 16px;
	}
	
	.productDetail .checkAllBox .el-checkbox__inner,
	.productDetail .checkAllBox2 .el-checkbox__inner {
		border: 1px solid #6a6a6a!important;
		background-color: #6a6a6a;
		border-radius: 0!important;
	}
	
	.productDetail .checkAllBox .el-checkbox__input.is-checked+.el-checkbox__label,
	.productDetail .checkAllBox2 .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #409eff;
	}
	
	.productDetail .checkAllBox .el-checkbox__label,
	.productDetail .checkAllBox2 .el-checkbox__label {
		color: #6a6a6a;
	}
	
	.productDetail .parserClass2 {
		display: inline-block;
		width: 210px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 10px 6px 4px;
		border: 1px solid #439DFD;
		border-radius: 4px;
	}
	
	.productDetail .parserClass3 {
		display: inline-block;
		width: 210px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 10px 6px 4px;
		border: 1px solid #6A6A6A;
		border-radius: 4px;
	}
	
	.productDetail .el-checkbox__input.is-disabled+span.el-checkbox__label {
		color: #666;
		cursor: not-allowed;
	}
	
	.productDetail .parserClass3 .el-checkbox {
		color: #6A6A6A;
	}
	
	.productDetail .parserClass3 .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.productDetail .parserClass3 .el-checkbox__inner {
		border: 1px solid #6A6A6A!important;
		background-color: #6A6A6A;
		border-radius: 0!important;
	}
	
	.productDetail .parserClass3 .el-checkbox__input.is-checked .el-checkbox__inner,
	.productDetail .parserClass3 .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6A6A6A;
		border-color: #6A6A6A!important;
	}
	
	.productDetail .transDialog .el-dialog__footer {
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/Product/ProductDetail.vue